import NotificationAlertImpersonate from './NotificationAlertImpersonate';

export default NotificationAlertImpersonate;
